<template>
  <!-- <ChildComponent v-model="pageTitle" />
  <ChildComponent
  :modelValue="pageTitle"
  @update:modelValue="pageTitle = $event"
  />-->
  <div class="c-input" :class="classStr">
    <slot name="prefix"></slot>
    <span class="label">
      {{label}}
      <i class="star" v-show="required">*</i>
    </span>
    <div class="input-wrap">
      <input
        :value="modelValue"
        :maxlength="maxlength"
        :minlength="minlength"
        :placeholder="placeholder"
        :type="type"
        :disabled="!!disabled"
        :name="name"
        :readonly="!!readonly"
        :max="max"
        :min="min"
        :step="step"
        :resize="!!resize"
        :autofocus="!!autofocus"
        :tabindex="tabindex"
        @change="change"
        @blur="blur"
        @focus="focus"
        @input="input"
      />
      <i
        @click="clear"
        v-show="clearable && modelValue!='' && modelValue!=null"
        class="iconfont icon-shanchujiaobiao"
      ></i>
      <slot name="suffix"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Number, Object, String],
      default: '',
    }, //原生属性
    label: {
      type: String,
      default: '标签',
    }, //label
    labelDirection: {
      type: String,
      default: 'column',
    },
    maxlength: {
      type: [String, Number],
      default: 9999,
    }, //原生属性
    minlength: {
      type: [String, Number],
      default: 0,
    }, //原生属性
    showWordLimit: {
      type: Boolean,
      default: false,
    }, //Todo...
    placeholder: {
      type: String,
      default: '',
    }, //原生属性
    clearable: {
      type: Boolean,
      default: false,
    }, //Todo...
    type: {
      type: String,
      default: 'input',
    }, //原生属性 textarea Todo...
    disabled: {
      type: Boolean,
      default: false,
    }, //原生属性
    name: {
      type: String,
      default: '',
    }, //原生属性
    readonly: {
      type: String,
      default: '',
    }, //原生属性，是否只读
    max: {
      type: [String, Number],
      default: Infinity,
    }, //原生属性，设置最大值
    min: {
      type: [String, Number],
      default: -Infinity,
    }, //原生属性，设置最小值
    step: {
      type: [String, Number],
      default: 1,
    }, //原生属性，设置输入字段的合法数字间隔
    resize: {
      type: Boolean,
      default: false,
    }, //控制是否能被用户缩放
    outline: {
      type: Boolean,
      default: false,
    }, //全边框输入框
    autofocus: {
      type: Boolean,
      default: false,
    }, //原生属性，自动获取焦点
    tabindex: {
      type: String,
      default: '',
    }, //输入框的tabindex
    size: {
      type: String,
      default: 'middle', //large big middle small xs
    },
    textAlign: {
      type: String,
      default: 'right',
    },
  },
  emits: ['blur', 'focus', 'change', 'input', 'clear', 'update:modelValue'],
  data() {
    return {
      classArr: [],
      classStr: '',
    }
  },
  mounted() {
    this.classUpdate()
  },
  updated() {
    this.classUpdate()
  },
  methods: {
    classUpdate() {
      this.classArr = []
      this.disabled && this.classArr.push('disabled') //Todo...
      this.readonly && this.classArr.push('readonly') //Todo...
      this.outline && this.classArr.push('outline')
      this.required && this.classArr.push('required')
      this.showWordLimit && this.classArr.push('limit') //Todo...
      this.clearable && this.classArr.push('clearable') //Todo...
      this.classArr.push(this.size ? this.size : 'middle')
      this.classArr.push(this.type) // Todo...
      if (this.labelDirection == 'vertical') {
        this.classArr.push('label-vertical')
      } else {
        this.classArr.push('label-horizontal')
      }
      this.classStr = this.classArr.join(' ')
    },
    blur($event) {
      this.$emit('blur', $event.target.value)
    },
    focus($event) {
      this.$emit('focus', $event.target.value)
    },
    change($event) {
      this.$emit('change', $event.target.value)
    },
    input($event) {
      this.$emit('update:modelValue', $event.target.value)
      this.$emit('input', $event.target.value)
    },
    clear() {
      this.$emit('update:modelValue', '')
      this.$emit('clear')
    },
  },
}
</script>

<style lang="less" scoped>
/**输入框 */
.label-vertical.c-input{
  display: block;
}
.c-input {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 30px;
  line-height: 100px;
  border-bottom: 1px solid #e9e9e9;
  background: #fff;
  .input-wrap {
    flex: 1 0 0;
    display: flex;
  }
  input {
    flex: 1 0 0;
    font-size: 30px;
    text-align: v-bind(textAlign);
    padding: 16px 0;
    background: none;
  }
  .label {
    white-space: nowrap;
  }
}
/**边框输入框 */
.c-input.outline {
  height: 88px;
  border-radius: 8px;
  border: 2px solid #e4e4e4;
  padding: 0 20px;
  line-height: 86px;
  input {
    padding: 0 0 0 60px;
    text-align: v-bind(textAlign);
    height: 86px;
  }
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #aaaaaa;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #aaaaaa;
}

input:-ms-input-placeholder {
  color: #aaaaaa;
}

input::-webkit-input-placeholder {
  color: #aaaaaa;
}
.star {
  font-style: normal;
  font-size: 28px;
  color: #f60e0e;
  line-height: 28px;
}
.icon-shanchujiaobiao {
  font-size: 28px;
  color: #aaa;
}
</style>